import Text from '@zenbusiness/common-components/Text';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import Skeleton from '../Skeleton';

import { getDisplayName } from '../../pages/Orders/helpers/taskName';
import { getOrderTaskStatusFriendlyName } from '../../utils/orderTask';
import useStyles from './useStyles';

const Row = ({
  loading,
  orderTask
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      alignItems="flex-end"
    >
      {loading ? (
        <Skeleton width="200px" />
      ) : (
        <Text size="lg" bold color="focus50" className={classes.rowDate}>{format(parseISO(orderTask.createdDatetime), 'MMMM do, yyyy')}</Text>
      )}
      <Grid
        container
        direction="row"
        className={classes.row}
        justifyContent="space-between"
        alignItems="center"
      >
        {loading ? (
          <Grid item xs={12}>
            <Skeleton height="43px" />
          </Grid>
        ) : (
          <>
            <Grid
              item
              container
              xs={6}
              md={8}
              lg={8}
              direction="column"
              justifyContent="space-between"
              alignItems="flex-start"
              wrap="nowrap"
            >
              <Text size="lg" bold>{`${getDisplayName(orderTask)} ${orderTask.orderTaskJurisdiction ? `(${orderTask.orderTaskJurisdiction})` : ''}`}</Text>
            </Grid>
            <Grid
              item
              container
              xs={6}
              md={4}
              lg={4}
            >
              <Text size="md" bold color="peace40" tag="span" align="center" className={classes.pill}>
                {getOrderTaskStatusFriendlyName(orderTask)}
              </Text>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default Row;

Row.propTypes = {
  loading: PropTypes.bool,
  orderTask: PropTypes.shape({
    createdDatetime: PropTypes.string,
    orderTaskJurisdiction: PropTypes.string
  }).isRequired
};
